


























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IUser, EUserStatus, EUserGroup } from "@/components/shared/types";
import { User } from "@/components/User";
import { L } from "@/common/filters";
import { isString, isObject, isEmptyObject, createDate, sortObjectArray } from "@/common/utils";
import { ICodeList } from "@/components/map/types"
interface IAuditLog {
  Id: number;
  When: Date;
  UserId: String;
  Name: String;
  Surname: String;
  Type: String;
  What: String;
};

@Component({
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.fetchUserLogs();
      }
    }
  }
})
export default class UserLogs extends Vue {
  @Prop({
    default: null
  }) data: User;

  $user:User = new User();

  RowsPerPage = [15];
  showMini:boolean = true;
  loading:boolean = false;
  totalLogs:number = 0;
  pagination:any = {
    descending: true
  };

  logs:IAuditLog[] = [];
  logMinDate: Date = null;
  logFrom:Date = null;
  logTo:Date = null;
  logInsert: boolean = true;
  logUpdate: boolean = true;
  logDelete: boolean = true;
  logUser: boolean = true;

  get Title() : string {
    let t = L('userLog');
    if (this.logUser) {
      t += ' : ' + this.$user.FullName;
    }
    return t;
  }

  get headers() {
    return [{
          text: L('dateTime'),
          align: 'left',
          value: 'When'
        },{
          text: L('name'),
          align: 'left',
          value: 'Name'
        },{
          text: L('surname'),
          align: 'left',
          value: 'Surname'
        },{
          text: L('logAction'),
          align: 'left',
          value: 'What'
        }
      ];
  }

  created() {
    if (this.data && this.data instanceof User) {
      this.$user = this.data;
    } else {
      this.$user = this.User;
    }
  }

  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  async fetchUserLogs() {
    if (this.loading) {
      return;
    }
    try {
      let ops:string[] = [];
      ['Insert','Update','Delete'].forEach((op) => {
        if (this['log' + op]) {
          ops.push(op.substring(0,1))
        }
      });
      if (ops.length==0) {
        this.totalLogs = 0;
        this.logs = [];
        return;
      }
      let data: any = {
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
        types: ops.join(',')
      };
      if (this.logUser) {
        data.uid = this.$user.HalloId;
      }
      if (!!this.logFrom) {
        data.datefrom = this.logFrom.toISOStringWithTimeZone();
      }
      if (!!this.logTo) {
        data.dateto = this.logTo.toISOStringWithTimeZone();
      }
      if (this.User.isAdmins) {
        data.o = this.User.OrgCode;
      }

      this.loading = true;
      data = await this.User.requestResource('user/logs', 'GET', data);
      this.totalLogs = data.total;
      this.logs = data.lists.map((log) => {
        return {
          Id: log.txid,
          When: createDate(log.when_ts),
          UserId: log.uid,
          Name: log.username,
          Surname: log.surname,
          Type: log.types,
          What: log.what
        }
      });
      let sortBy = this.pagination.sortBy + (this.pagination.descending ? ' desc' : '');
      sortObjectArray(this.logs, sortBy);
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  };

  toggleOption(option:"Insert" | "Update" | "Delete" | "User") {
    let ops = 'log' + option;
    this[ops] = !this[ops];
    this.logs = [];
    this.totalLogs = 0;
    this.pagination.page = 1;
    this.fetchUserLogs();
  }

  listUsers() {
    this.$emit('changeMenu',{
      name: 'admin'
    });
  }
}
